import { mixed, string, object, number, boolean } from 'yup';
import { emptyValueCheck } from './customValidations';

export const LockerSearchValidation = object().shape({
  siteId: number().transform(emptyValueCheck).nullable(),
  compoundId: number().transform(emptyValueCheck).nullable(),
  cellNumber: number()
    .transform(emptyValueCheck)
    .nullable()
    .typeError('יש להזין מספרים בלבד'),
  cellId: number().typeError('יש להזין מספרים בלבד'),
  cellNickName: string(),
  closetNumber: number()
    .transform(emptyValueCheck)
    .nullable()
    .typeError('יש להזין מספרים בלבד'),
  lockCaseId: string().typeError('יש להזין מספרים בלבד'),
  cellStatus: number().transform(emptyValueCheck).nullable(),
  cellFormationId: number().transform(emptyValueCheck).nullable(),
  isAccessible: boolean().transform(emptyValueCheck).nullable(),
  fromPairingDate: mixed().test(
    'check fromPairingDate value',
    function (value) {
      const toPairingDate = this.parent.toPairingDate;

      if (!value) return true;

      return new Date(value) > new Date(toPairingDate)
        ? this.createError({
            message: 'טווח התאריכים שגוי',
            path: 'fromPairingDate',
          })
        : true;
    }
  ),
  toPairingDate: mixed().test('check toPairingDate value', function (value) {
    const fromPairingDate = this.parent.fromPairingDate;

    if (!value) return true;

    if (fromPairingDate) {
      return new Date(value) < new Date(fromPairingDate)
        ? this.createError({
            message: 'טווח התאריכים שגוי',
            path: 'toPairingDate',
          })
        : true;
    }

    return true;
  }),
});
